// extracted by mini-css-extract-plugin
export default {"contentBox":"ActivateUser_contentBox__Ifb+n","form":"ActivateUser_form__tbFX5","btn":"ActivateUser_btn__TEqoG"};